import React, { forwardRef, useState } from "react"
import { useDispatch } from "react-redux"
import { useTranslation } from "next-i18next"

import ProductActionsUI from "@/components/MultiFinshProductBundle/ui/ProductActionsUI"
import { getTranslations } from "@/components/Bundles/localization"
import { useStore } from "@/components/MultiFinshProductBundle/context/store"
import { showPreviewCart } from "@/store/features/genericSlice"
import { shareaddToCart } from "../sharedCart/shareCartHelper"
import {
  checkIsAllProductsAvailable,
  getAddToCartItems,
} from "@/components/MultiFinshProductBundle/utils"
import { bundleAddToCartAnalytics } from "@/components/MultiFinshProductBundle/analytics"

const ProductActions = (props, ref) => {
  const { productInfoBundle = {} } = props || {}
  const dispatch = useDispatch()

  const { state } = useStore()
  const {
    selectedProducts = [],
    bundleItems = [],
    pdpDetails = [],
    projectionData = [],
  } = state

  const { sku: bundleSku } = pdpDetails || {}

  const { t } = useTranslation("common")
  const staticTexts = getTranslations(t)

  const [quantity, setQuantity] = useState(1)
  const [loading, setLoading] = useState(false)

  const handleChange = (qty = 0) => {
    if (qty > 0) {
      setQuantity(qty)
    }
  }

  const onAddToCart = isFaild => {
    if (!isFaild) dispatch(showPreviewCart())
    setLoading(false)
  }

  const handleAddToCart = () => {
    setLoading(true)
    const bundleAddToCartData = []

    const updateProductInfoBundle = productInfoBundle.map(item => ({
      ...item,
      quantity: quantity,
    }))
    bundleAddToCartAnalytics(updateProductInfoBundle)
    const selectedSkus = selectedProducts?.map(selected => selected.sku) || []

    bundleAddToCartData.push({
      bundleId: bundleSku,
      selectedSkus: selectedSkus,
    })

    const items = getAddToCartItems(
      selectedProducts,
      bundleItems,
      projectionData,
      quantity,
      bundleAddToCartData
    )

    shareaddToCart(items, "", onAddToCart)
  }

  const isAllProductsAvailable = checkIsAllProductsAvailable(
    selectedProducts,
    projectionData
  )

  return (
    <div className="product-actions" ref={ref}>
      <ProductActionsUI
        quantity={quantity}
        loading={loading}
        handleChange={handleChange}
        staticTexts={staticTexts}
        handleAddToCart={handleAddToCart}
        isAllProductsAvailable={isAllProductsAvailable}
      />
    </div>
  )
}

export default forwardRef(ProductActions)
